import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from '@angular/forms';
import { ClientField } from '../../../domain/models';

export class DisclosureForm {
    private static _fb: UntypedFormBuilder;

    static initialize(fb: UntypedFormBuilder) {
        this._fb = fb;
        return fb.group({
            applicationId: [undefined, Validators.required],
            isParentSignatureRequired: [false]
        });
    }

    static setFields(fields: ClientField[], formGroup: UntypedFormGroup): void {
        fields.forEach((field) => {
            switch (field.fieldName) {
                case 'ReleaseOfInformation':
                    formGroup.addControl(
                        'releaseOfInformationIds',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('releaseOfInformationIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'DataSharingAgreed':
                    formGroup.addControl(
                        'dataSharingAgreed',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('dataSharingAgreed')
                            ?.addValidators([Validators.required]);
                    break;
                case 'StudentSignatureFirstName':
                    formGroup.addControl(
                        'studentFirstName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('studentFirstName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'StudentSignatureLastName':
                    formGroup.addControl(
                        'studentLastName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('studentLastName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'StudentSignatureDate':
                    formGroup.addControl(
                        'studentSignatureDate',
                        this._fb.control(undefined, [
                            this.currentDateValidator()
                        ])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('studentSignatureDate')
                            ?.addValidators([Validators.required]);
                    break;
                case 'StudentSignatureApproval':
                    formGroup.addControl(
                        'studentHasSigned',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('studentHasSigned')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ParentSignatureFirstName':
                    formGroup.addControl(
                        'parentFirstName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('parentFirstName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ParentSignatureLastName':
                    formGroup.addControl(
                        'parentLastName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('parentLastName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ParentSignatureDate':
                    formGroup.addControl(
                        'parentSignatureDate',
                        this._fb.control(undefined, [
                            this.currentDateValidator()
                        ])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('parentSignatureDate')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ParentSignatureApproval':
                    formGroup.addControl(
                        'parentHasSigned',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('parentHasSigned')
                            ?.addValidators([Validators.required]);
                    break;
            }
        });
    }

    private static currentDateValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (
                control === null ||
                control.value === undefined ||
                control.value === null
            )
                return null;

            // Is the date within 30 days of today?
            const currentDate = new Date(control.value);
            const today = new Date();
            const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000;
            const invalidDate =
                Math.abs(currentDate.getTime() - today.getTime()) >
                thirtyDaysInMilliseconds;

            return invalidDate ? { invalidDate: true } : null;
        };
    }
}
